export const priceMasterType = {
  master: 'price',
  top: 'priceTop',
  artDirector: 'priceArt',
};

export const masterTypes = ['master', 'top', 'artDirector'];
